export enum ServiceCategory {
  Installation = 'Installation',
  FAT = 'FAT',
  WheelSpacingChange = 'Wheel Spacing Change',
  WheelSwap = 'Wheel Swap',
  WheelSwapNoReset = 'Wheel Swap (No Reset)',
  AlphaBoltSwap = 'Alpha Bolt Swap',
  BallReplacement = 'Ball Replacement',
  PlateDistanceChange = 'Plate Distance Change',
  FirmwareUpgrade = 'Firmware Upgrade',
  Other = 'Other',
}

export const isCategoryReadOnly = (category: ServiceCategory) => {
  switch (category) {
    case ServiceCategory.FirmwareUpgrade:
    case ServiceCategory.PlateDistanceChange: {
      return true;
    }

    default: {
      return false;
    }
  }
};

export const shouldCategoryResetTraining = (category: ServiceCategory) => {
  switch (category) {
    case ServiceCategory.AlphaBoltSwap:
    case ServiceCategory.FAT:
    case ServiceCategory.Installation:
    case ServiceCategory.WheelSpacingChange:
    case ServiceCategory.WheelSwap: {
      return true;
    }

    default: {
      return false;
    }
  }
};
